import { useApiPut } from '@sierralabs/core-ui';
export function useUpdateEntityData(tableName, dataId) {
    const { data, isLoading, error, put } = useApiPut(`entities/${tableName}/data/${dataId}`);
    return {
        updatedEntityData: data,
        isUpdatingData: isLoading,
        error,
        updateEntityData: put
    };
}
//# sourceMappingURL=useUpdateEntityData.js.map